import React, { useRef, useEffect, useState } from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { RadarChart as MuiRadarChart } from "@mui/x-charts/RadarChart";
import { formatChartTitle } from "../../utils";

interface RadarChartData {
  [key: string]: string | number;
}

interface RadarChartProps {
  data: RadarChartData[];
  seriesKeys: string[];
  seriesLabels: string[];
  metricKey?: string;
  title?: string;
  height?: number;
  colors?: string[];
  max?: number;
}

export const RadarChart: React.FC<RadarChartProps> = ({
  data,
  seriesKeys,
  seriesLabels,
  metricKey = "metric",
  title,
  height = 400,
  colors,
  max = 100,
}) => {
  const theme = useTheme();
  const containerRef = useRef<HTMLDivElement>(null);
  const formattedTitle = formatChartTitle(title);

  const defaultColors = [
    theme.palette.primary.main,
    theme.palette.secondary.main,
  ];

  const metrics = data.map((item) => String(item[metricKey]));

  const series = seriesKeys.map((key, index) => ({
    data: data.map((item) => item[key] as number),
    label: seriesLabels[index],
    areaStyle: { fillOpacity: 0.1 },
  }));

  return (
    <Box ref={containerRef} sx={{ width: "100%" }}>
      {formattedTitle && (
        <Typography variant="h6" fontWeight={600} gutterBottom>
          {formattedTitle}
        </Typography>
      )}
      <MuiRadarChart
        height={height}
        series={series}
        radar={{
          metrics: metrics,
          max: max,
        }}
        colors={colors || defaultColors}
        margin={{ left: 0, right: 0, top: 20, bottom: 20 }}
      />
    </Box>
  );
};
